import { AIR_REQUEST_ID_QUERY_KEY } from '@/app/(main)/air-request/consts/air-request-const';
import { TAB_QUERY_KEY } from '@/app/(main)/client-detail/consts/client-detail';
import type { ClientTabsType } from '@/app/(main)/client-detail/types';
import { CLIENT_ID_QUERY_KEY } from './const';
import { AIR_REQUEST_PATH, INTERNAL_CLIENTS_PATH, CLIENT_DETAIL_INTERNAL_PATH } from './paths';

export const getClientDetailPath = (clientId: ClientTabsType | string | null, tab: ClientTabsType) => {
  if (!clientId) return `${INTERNAL_CLIENTS_PATH}`;
  return `${CLIENT_DETAIL_INTERNAL_PATH}?${CLIENT_ID_QUERY_KEY}=${clientId}&${TAB_QUERY_KEY}=${tab}`;
};

export const getAirRequestPath = (airRequestId?: string, clientId?: string) => {
  return `${AIR_REQUEST_PATH}?${AIR_REQUEST_ID_QUERY_KEY}=${airRequestId}&${CLIENT_ID_QUERY_KEY}=${clientId}`;
};